import { H, W } from "./render/arena.ts";
import type { Ctx } from "./render/util.ts";

export type SceneFn = (ctx: Ctx, now: number, dt: number) => void;

const stage = document.getElementById("stage") as HTMLDivElement;
const canvas = document.getElementById("canvas") as HTMLCanvasElement;
export const ui = document.getElementById("ui") as HTMLDivElement;
const context = canvas.getContext("2d");
if (!context) throw new Error("Canvas 2D is not supported in this browser");
const ctx: Ctx = context;

let scene: SceneFn = () => {};
let pixelRatio = 1;

export function setScene(fn: SceneFn): void {
  scene = fn;
}

export function now(): number {
  return performance.now() / 1000;
}

function fit(): void {
  const scale = Math.min(window.innerWidth / W, window.innerHeight / H);
  stage.style.transform = `translate(-50%, -50%) scale(${scale})`;
  pixelRatio = Math.min(2.5, Math.max(1, scale * window.devicePixelRatio));
  canvas.width = Math.round(W * pixelRatio);
  canvas.height = Math.round(H * pixelRatio);
}

let last = now();
function frame(): void {
  const t = now();
  const dt = Math.min(0.05, t - last);
  last = t;
  ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
  ctx.clearRect(0, 0, W, H);
  scene(ctx, t, dt);
  requestAnimationFrame(frame);
}

export function startEngine(): void {
  fit();
  window.addEventListener("resize", fit);
  requestAnimationFrame(frame);
}
